<script setup lang="ts">
defineProps<{
  text: string
}>()
</script>

<template>
  <div v-animate="{ animation: 'vertical-reveal' }" class="text-intro" v-html="text" />
</template>
